import { apiClient } from './client';
import type { Recipe, ListRecipesQuery, ListRecipesResponse, CreateRecipeRequest, UpdateRecipeRequest } from '@/types/api';

export async function getRecipes(params?: ListRecipesQuery): Promise<ListRecipesResponse> {
  const response = await apiClient.get<ListRecipesResponse>('/recipes', { params });
  return response.data;
}

export async function getRecipe(id: number): Promise<Recipe> {
  const response = await apiClient.get<Recipe>(`/recipes/${id}`);
  return response.data;
}

export async function createRecipe(data: CreateRecipeRequest): Promise<Recipe> {
  const response = await apiClient.post<Recipe>('/recipes', data);
  return response.data;
}

export async function updateRecipe(id: number, data: UpdateRecipeRequest): Promise<Recipe> {
  const response = await apiClient.patch<Recipe>(`/recipes/${id}`, data);
  return response.data;
}

export async function deleteRecipe(id: number): Promise<void> {
  await apiClient.delete(`/recipes/${id}`);
}
